import { BannerFormat, LEADERBOARD_FORMAT, MOBILE_LEADERBOARD_FORMAT } from './useAdStructs'

export const AD_PLACEMENT_CODES = {
  // Home
  home_cluster: 'home_cluster', // Old ad struct system (HomeAdCluster)
  home_bottom: 'home_bottom', // Ads2 system (HomeAdBannerOnly)

  // Control
  control_top: 'control_top',
  control_bottom: 'control_bottom',

  control_modules_bottom: 'control_modules_bottom', // Not implemented yet
  control_inverters_bottom: 'control_inverters_bottom', // Not implemented yet
  control_batteries_bottom: 'control_batteries_bottom',
  control_others_bottom: 'control_others_bottom', // Not implemented yet

  control_module_activation_bottom: 'control_module_activation_bottom', // Not implemented yet
  control_inverter_activation_bottom: 'control_inverter_activation_bottom', // Not implemented yet
  control_battery_activation_bottom: 'control_battery_activation_bottom',
  control_other_activation_bottom: 'control_other_activation_bottom', // Not implemented yet

  // Shop
  shop_multi_project_ordering: 'shop_multi_project_ordering',
  shop_bom_bottom: 'shop_bom_bottom',
  shop_category_module_bottom: 'shop_category_module_bottom',
  shop_category_inverter_bottom: 'shop_category_inverter_bottom',
  shop_category_battery_bottom: 'shop_category_battery_bottom',
  shop_category_other_bottom: 'shop_category_other_bottom',

  // Hardware
  hardware_selection_module_top: 'hardware_selection_module_top',
  hardware_selection_module_bottom: 'hardware_selection_module_bottom',
  hardware_selection_inverter_top: 'hardware_selection_inverter_top',
  hardware_selection_inverter_bottom: 'hardware_selection_inverter_bottom',
  hardware_selection_battery_top: 'hardware_selection_battery_top',
  hardware_selection_battery_bottom: 'hardware_selection_battery_bottom',
  hardware_selection_other_top: 'hardware_selection_other_top',
  hardware_selection_other_bottom: 'hardware_selection_other_bottom',
  hardware_search_top: 'hardware_search_top',
  hardware_search_bottom: 'hardware_search_bottom',

  // Project
  project_manage: 'project_manage',
  project_proposal_top: 'project_proposal_top',

  // Expo
  expo_homepage_top: 'expo_homepage_top',
  expo_homepage_bottom: 'expo_homepage_bottom',
} as const

export type AdPlacementCode = typeof AD_PLACEMENT_CODES[keyof typeof AD_PLACEMENT_CODES]

// If not found it will default to 3 (moderate)
const AD_INTENSITY_BY_PLACEMENT_CODE: Record<AdPlacementCode, number> = {
  // Home
  [AD_PLACEMENT_CODES.home_cluster]: 2, // Old ad struct system (HomeAdCluster)
  [AD_PLACEMENT_CODES.home_bottom]: 2, // Ads2 system (HomeAdBannerOnly)

  // Control
  [AD_PLACEMENT_CODES.control_top]: 3,
  [AD_PLACEMENT_CODES.control_bottom]: 1,
  [AD_PLACEMENT_CODES.control_modules_bottom]: 2, // Not implemented yet
  [AD_PLACEMENT_CODES.control_inverters_bottom]: 2, // Not implemented yet
  [AD_PLACEMENT_CODES.control_batteries_bottom]: 2,
  [AD_PLACEMENT_CODES.control_others_bottom]: 2, // Not implemented yet
  [AD_PLACEMENT_CODES.control_module_activation_bottom]: 2, // Not implemented yet
  [AD_PLACEMENT_CODES.control_inverter_activation_bottom]: 2, // Not implemented yet
  [AD_PLACEMENT_CODES.control_battery_activation_bottom]: 2,
  [AD_PLACEMENT_CODES.control_other_activation_bottom]: 2, // Not implemented yet

  // Shop
  [AD_PLACEMENT_CODES.shop_multi_project_ordering]: 3,
  [AD_PLACEMENT_CODES.shop_bom_bottom]: 2,
  [AD_PLACEMENT_CODES.shop_category_module_bottom]: 2,
  [AD_PLACEMENT_CODES.shop_category_inverter_bottom]: 2,
  [AD_PLACEMENT_CODES.shop_category_battery_bottom]: 2,
  [AD_PLACEMENT_CODES.shop_category_other_bottom]: 2,

  // Hardware
  [AD_PLACEMENT_CODES.hardware_selection_module_top]: 3,
  [AD_PLACEMENT_CODES.hardware_selection_module_bottom]: 2,
  [AD_PLACEMENT_CODES.hardware_selection_inverter_top]: 3,
  [AD_PLACEMENT_CODES.hardware_selection_inverter_bottom]: 2,
  [AD_PLACEMENT_CODES.hardware_selection_battery_top]: 3,
  [AD_PLACEMENT_CODES.hardware_selection_battery_bottom]: 2,
  [AD_PLACEMENT_CODES.hardware_selection_other_top]: 3,
  [AD_PLACEMENT_CODES.hardware_selection_other_bottom]: 2,
  [AD_PLACEMENT_CODES.hardware_search_top]: 3,
  [AD_PLACEMENT_CODES.hardware_search_bottom]: 2,

  // Project
  [AD_PLACEMENT_CODES.project_manage]: 3,
  [AD_PLACEMENT_CODES.project_proposal_top]: 4,

  // Expo
  [AD_PLACEMENT_CODES.expo_homepage_top]: 3,
  [AD_PLACEMENT_CODES.expo_homepage_bottom]: 2,
}

export const getAdIntensityForPlacement = (placementCode: AdPlacementCode): number => {
  return AD_INTENSITY_BY_PLACEMENT_CODE[placementCode] ?? 3
}

export const LEADERBOARD_FORMATS: BannerFormat[] = [LEADERBOARD_FORMAT, MOBILE_LEADERBOARD_FORMAT]
